(function () {
    "use strict";

    angular.module('app').directive('shareholders', ShareHoldersDirective);

    ShareHoldersDirective.$inject = ['translationsService', 'habilBootbox'];
    function ShareHoldersDirective(translationsService, habilBootbox) {
        return {
            restrict: 'E',
            // eslint-disable-next-line angular/no-directive-replace
            replace: true,
            scope: {
                nationalities: '=',
                shareholdersJson: '=',
                isReadonly: '='
            },
            template: `<div>
                <p ng-if="!shareholdersArePresent()" style="color: red;border-bottom: red solid;">{{translations.RequestFVM_Shareholders_Are_Mandatory}}</p>
                <button class="btn btn-primary" ng-click="addShareholder()" style="margin-bottom: 10px" ng-disabled="!canAddShareholder()" ng-if="!isReadonly">{{translations.RequestFVM_Shareholders_Add}}</button>
                <div ng-if="shareholdersArePresent()">
                    <ul class="list-group">
                        <li ng-repeat="s in shareholders track by $index" class="list-group-item" style="border-radius: 0;">
                            <p>{{ s.name }} ({{ (nationalities | filter:{Key: s.nationality }:true | limitTo:1)[0].Value }}) , {{ s.percentage }}%  
                            <i class="fa fa-pencil" style="cursor: pointer" aria-hidden="true" ng-if="!isReadonly" ng-click="editShareholder(s, $index)"></i>
                            <i class="fa fa-times" style="cursor: pointer;color:red;" aria-hidden="true" ng-if="!isReadonly" ng-click="deleteShareholder($index)"></i>
                            </p>    
                        </li>    
                    </ul>
                </div>
            </div>`,
            link: (scope) => {
                translationsService.loadTranslations((translations) => scope.translations = translations);
                scope.shareholders = [];

                const parseShareholders = (data) => {
                    try {
                        if (!data)
                            return;
                        scope.shareholders = JSON.parse(data);
                    } catch { }
                };

                scope.$watch('shareholdersJson', parseShareholders);
                scope.shareholdersArePresent = () => scope.shareholdersJson && scope.shareholders && scope.shareholders.length > 0;

                scope.shareholder = {};
                scope.addShareholder = () => {
                    scope.shareholder = { isNew: true, percentage: scope.getNewAmount(), nationality: 'BE' };
                    scope.showDialog();
                };
                scope.deleteShareholder = (index) => {
                    scope.shareholders.splice(index, 1);
                    scope.shareholdersJson = JSON.stringify(scope.shareholders);
                };
                scope.editShareholder = (s, index) => {
                    if (!s)
                        return;
                    scope.shareholder = s;
                    scope.showDialog(index);
                };
                scope.canAddShareholder = () => {
                    let total = 0;
                    scope.shareholders.forEach(x => total += parseFloat(x.percentage));
                    return total < 100;
                };
                scope.getNewAmount = () => {
                    let total = 0;
                    scope.shareholders.forEach(x => total += parseFloat(x.percentage));
                    return (100 - total) < 20 ? (100 - total) : 20;
                };
                scope.validateAction = () => {
                    const s = scope.shareholder;
                    if (!s.percentage)
                        return;
                    if (isNaN(parseFloat(s.percentage))) {
                        alert(scope.translations.RequestFVM_Shareholders_PercentageError);
                        s.percentage = 20;
                    } else {
                        let total = 0;
                        scope.shareholders.forEach(x => total += parseFloat(x.percentage));
                        total += (typeof s.isNew !== 'undefined') ? parseFloat(s.percentage) : 0;
                        if (total > 100) {
                            s.percentage = 20;
                            alert(scope.translations.RequestFVM_Shareholders_PercentageMaxError);
                        }
                    }
                };
                scope.processShareholder = (index) => {
                    let s = scope.shareholder;
                    s = { name: s.name, percentage: s.percentage, nationality: s.nationality };
                    if (!s || !s.name || !s.percentage || !s.nationality) {
                        alert(scope.translations.RequestFVM_Shareholders_FieldsEmptyError);
                        return false;
                    }
                    s.percentage = parseFloat(s.percentage);
                    if (typeof index !== 'undefined')
                        scope.shareholders.splice(index, 1);
                    scope.shareholders.push(s);
                    scope.shareholdersJson = JSON.stringify(scope.shareholders);
                    scope.$apply();
                    return true;
                };

                scope.showDialog = (index) => {
                    habilBootbox.customDialog({
                        templateHtml: `<div class="container-fluid">
                            <strong>{{translations.RequestFVM_Shareholders_Only20Percent}}</strong>
                            <div class="row">
                                <div class="col-md-4">
                                    <input type="text" class="form-control" placeholder="{{translations.RequestFVM_Shareholders_NameField}}" 
                                    ng-model="shareholder.name" ng-change="validateAction()" />
                                </div>
                                <div class="col-md-4">
                                    <div class="input-group">
                                        <input type="text" class="form-control" placeholder="{{translations.RequestFVM_Shareholders_PercentageField}}" 
                                        ng-model="shareholder.percentage" ng-change="validateAction()" />
                                        <span class="input-group-addon">%</span>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="input-group">
                                        <select
                                            class="form-control" 
                                            ng-required="true" 
                                            ng-model="shareholder.nationality"
                                            ng-options="item.Key as item.Value for item in nationalities"
                                            type="number" 
                                            required="required">
                                            <option value="" disabled selected>{{translations.Person_CurrentNationality}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>`,
                        scope: scope,
                        title: scope.translations.RequestFVM_Shareholders_DialogTitle,
                        size: 'large',
                        onEscape: true,
                        buttons: {
                            ok: { label: 'OK', className: 'btn-primary', callback: () => scope.processShareholder(index) },
                        }
                    });
                };
            }
        };
    }
})();
